var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Aedu.FileUploadView = function (superClass) {
  extend(FileUploadView, superClass);
  function FileUploadView() {
    return FileUploadView.__super__.constructor.apply(this, arguments);
  }
  FileUploadView.prototype.template = 'core_post_webpack/profile_helpers/file_upload';
  FileUploadView.prototype.events = {
    'change .js-file-input': 'uploadFile',
    'drop .js-dropzone': 'uploadFile',
    'dragover .js-dropzone': 'dragover',
    'dragleave .js-dropzone': 'dragleave'
  };
  FileUploadView.prototype.initialize = function () {
    this.buttonClasses = this.options.buttonClasses;
    return this.uploader = new Aedu.FileUploader({
      maxSize: this.options.maxSize,
      fileTypes: this.options.fileTypes,
      url: this.options.url
    });
  };
  FileUploadView.prototype.render = function () {
    return this.$el.html(JST[this.template]({
      buttonClasses: this.buttonClasses
    }));
  };
  FileUploadView.prototype.showSpinner = function () {
    $('.upload-container').addClass('u-displayNone');
    return $('.js-uploader-spinner').removeClass('u-displayNone');
  };
  FileUploadView.prototype.hideSpinner = function () {
    $('.upload-container').removeClass('u-displayNone');
    return $('.js-uploader-spinner').addClass('u-displayNone');
  };
  FileUploadView.prototype.uploadFile = function (e) {
    var file;
    e.preventDefault();
    e.stopPropagation();
    $('.js-errors').addClass('u-displayNone');
    if (e.originalEvent.dataTransfer != null) {
      file = e.originalEvent.dataTransfer.files[0];
    } else {
      file = e.target.files[0];
    }
    if (file != null) {
      this.showSpinner();
      return this.uploader.upload(file).done(this.done.bind(this)).fail(this.fail.bind(this));
    }
  };
  FileUploadView.prototype.dragover = function (e) {
    e.preventDefault();
    return e.stopPropagation();
  };
  FileUploadView.prototype.dragleave = function (e) {
    e.preventDefault();
    return e.stopPropagation();
  };
  FileUploadView.prototype.done = function () {
    var successText;
    successText = this.options.successText || "Your file has been successfully uploaded!";
    $('.js-success').text(successText);
    $('.js-uploader-spinner').addClass('u-displayNone');
    $('.js-file-uploaded').removeClass('u-displayNone');
    if (window.location.search === "?update_research_interests=true") {
      return window.location.replace(window.location.pathname);
    } else {
      return window.location.reload();
    }
  };
  FileUploadView.prototype.fail = function (res) {
    this.hideSpinner();
    $('.js-errors').text(this.translateError(res.error));
    return $('.js-errors').removeClass('u-displayNone');
  };
  FileUploadView.prototype.translateError = function (error) {
    switch (error) {
      case 'size-too-large':
        return 'Please choose a smaller file';
      case 'invalid-type':
        return "Sorry, we don't support that file type.";
      case 'file-name-too-long':
        return 'Sorry, your file name is too long to upload. Please shorten to 125 characters or less.';
      default:
        return 'Sorry, something went wrong! Your upload may or may not have finished. Please refresh the page, and try again if the uploaded file does not appear.';
    }
  };
  return FileUploadView;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;